import { DirectiveBinding, DirectiveFunction } from 'vue/types/options'

const directive = {
  bind(el: HTMLImageElement, binding: DirectiveBinding) {
    const { value } = binding
    const defaultError = require('@/assets/default/logo.png')
    const defaultType: any = {
      tournamentLogo: require('@/assets/default/tournament_logo.png'),
      tournamentBackground: require('@/assets/default/tournament_background.png')
    }
    const img = new Image()

    let error = defaultError
    let original = el.src

    if (typeof value === 'string') {
      error = value
    }

    if (value instanceof Object) {
      error = defaultType[value.type] || defaultError
    }

    img.src = original

    img.onerror = () => {
      el.src = error
    }
  }
}

export default directive as DirectiveFunction
